
const initialData = {
    requisitionId: 0,
    requistionDocData: {},
    requisitionNo: '', 
    redirectRfq: false,
}


const PrRfqReducer = (state=initialData, action)=>{
    let newState = {...state};
    switch(action.type){
        case 'update_req':
            newState = {...state, ...action.payload};
            break;
        case 'reset_req':
            newState = {...state, ...initialData}
            break;
    };

    return newState;
};

export default PrRfqReducer;